import { Row, Col } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import React,{useState} from 'react';
import { useApiClient } from "../../ApiService/useApiClient";

export const tableColumns = [  
  {
      name: "Communication History",
      selector: (row) => (
        <>
        <span className="p-5">
        <h6>{row.note}</h6>     
        <p><em>Added on {row.dateCreated}, by : {row.createdByUser}</em>
         ( <em>Category : {row.noteType}</em> ) </p>
        </span> 
        </>
      ), 
      sortable: true,
      
    },  
];



const CustomerNotes = ({datainfo}) => {

  const api = useApiClient();
  const [data,setdata] = useState(datainfo.customerNotes);
  const [show, setShow] = useState(false);
  const [error, setError] = useState();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formValue, setformValue] = useState({

    CustomerId : datainfo.customerId,
    NoteType: 'general',
    Note:''

  })

  const handleChange = (event) => {
    setformValue({
      ...formValue,
      [event.target.name]: event.target.value
    });
    //console.log(event.target.name +'=='+ event.target.value)
  }

  const handleSubmit = async() => {
    // store the states in the form data
    const frmFormData = new FormData();
    frmFormData.append("CustomerId", datainfo.customerId)
    frmFormData.append("NoteType", formValue.NoteType)
    frmFormData.append("Note", formValue.Note)  
    
    const sURL = "HMCareData/customer/addnote/";

      api.post(sURL,frmFormData)
        .then((Response)=>{
            setdata([...data,Response.data]);
            console.log(Response.data)
        }).catch(error => {
            setError(error);     
            //console.log({error})
        });

        //data = {...data, {customerId:}}  

        handleClose()

  }




  return (
    <>


    {/* <Button variant="primary" onClick={handleShow}>
      Add new Note
    </Button> */}

    <Row className="mb-3">
      <Col className="d-flex justify-content-end">
        <Button 
          variant="outline-primary" 
          onClick={handleShow} 
          size="sm"> + Add New Note </Button>
      </Col>
    </Row>

    <Row>

      <DataTable tableClassName="data-table-head-light table-responsive" data={data} columns={tableColumns} striped={true} highlightOnHover={true} filterFieldName={""} pagination={true}  />    
    </Row>

{show && 
    <Modal show={show} onHide={handleClose} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>Add Note</Modal.Title>
  </Modal.Header>

  <Form onSubmit={handleSubmit}>   
  <Modal.Body>
 
     <Form.Group className="form-group">
        <Form.Label htmlFor="exampleFormControlInputText5">Category</Form.Label>
        <div className="form-control-wrap">
            <Form.Select id="exampleFormControlInputText5" name="NoteType" aria-label="Default select example" onChange={handleChange}>
                <option value="general">Communication</option>
                {/* <option value="general">General</option>
                <option value="review">Review</option>                 */}
            </Form.Select>
        </div>
    </Form.Group> 

    <Form.Group className="mb-3" controlId="Note" >
      <Form.Label>Note</Form.Label>
      <Form.Control as="textarea" rows={3} name="Note" onChange={handleChange} />
    </Form.Group>  
    
  
  </Modal.Body>
  <Modal.Footer>                    
      <Button variant="danger" onClick={handleClose}>Cancel</Button>
      <Button variant="primary" type="submit" >Add Note</Button>              
  </Modal.Footer>
</Form>
  {/* <Modal.Footer>
    <Button variant="primary" onClick={handleSubmit} >
      Save 
    </Button>
    <Button variant="secondary" onClick={handleClose}>
      Close
    </Button>
  </Modal.Footer> */}
</Modal>}

    </>
  )
}

export default CustomerNotes